import { Container, SpineBase, dispatcher, ingenuity, IEvent } from "@quest/base-core";
import { WildDragonReelViewBG } from "./WildDragonReelViewBG";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { GameParserModel } from "../../Platform/GameParserModel";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";
import { gameConstants } from "../../Constants/gameConstants";

export class WildDragonReelControllerBG {
    protected view: WildDragonReelViewBG;
    protected wildDragonOnReelMainContainer: Container;
    protected currentLandedWilds: number[] = [];
    constructor(view: WildDragonReelViewBG) {
        this.view = view;
        this.subscribeEvent();
        this.initializeElements();
    }

    /**
  * method init: initialize the other functions of StackSymbolFeatureController class.
  */
    private initializeElements(): void {
        this.wildDragonOnReelMainContainer = this.view.getContainerByID("wildDragonOnReelMainContainer") as Container;
    }
    /**
   * Subscribe events
   */
    private subscribeEvent(): void {
        this.unSubscribeEvent();
        dispatcher.on(eventDispatchers.START_WILD_DRAGON_FEATURE, this.startWildDragonFeature, this);
        dispatcher.on(eventDispatchers.PLAY_EAT_FLOWER_ANIM, this.eatFlowerAnim, this);
        dispatcher.on(eventDispatchers.PLAY_WILD_DRAGON_WIN_ANIM, this.playWildWinAnim, this);
        dispatcher.on(eventDispatchers.SUPSPEPND_WILD_DRAGON_WIN, this.suspendWildDragonWin, this);
        dispatcher.on(eventDispatchers.RESET_GLOW_EFFECT_ANIMATION, this.view.resetGlowAnimations, this.view);
        dispatcher.on(eventDispatchers.PURPLE_TO_GOLD_WILD_ANIM, this.purpleWildToGoldAnim, this);
        dispatcher.on(eventDispatchers.REMOVE_WILD_FROM_REEL, this.removeWildAfterCompletion, this);
        dispatcher.on(eventDispatchers.RESET_WILD_ON_REEL, this.resetWildPanel, this);
        dispatcher.on(eventDispatchers.COLLECTED_WILD_ON_BET_CHANGE, this.showCollectedWildOnNewBet, this);
        dispatcher.on(eventDispatchers.COLLECTED_WILD_ON_BROKEN, this.showCollectedWildOnBroken, this);
        dispatcher.on(eventDispatchers.HANDLE_TINT_WILD_SYMBOL, this.handleWildOnAnticipation, this);
        dispatcher.on(eventDispatchers.HANDLE_WILD_REEL_DURING_TOGGLE, this.handleWildReelTogglePresentation, this);
    }

    /**
     * Unsubscribe events
    */
    private unSubscribeEvent(): void {
        dispatcher.off(eventDispatchers.START_WILD_DRAGON_FEATURE, this.startWildDragonFeature, this);
        dispatcher.off(eventDispatchers.PLAY_EAT_FLOWER_ANIM, this.eatFlowerAnim, this);
        dispatcher.off(eventDispatchers.PLAY_WILD_DRAGON_WIN_ANIM, this.playWildWinAnim, this);
        dispatcher.off(eventDispatchers.SUPSPEPND_WILD_DRAGON_WIN, this.suspendWildDragonWin, this);
        dispatcher.off(eventDispatchers.PURPLE_TO_GOLD_WILD_ANIM, this.purpleWildToGoldAnim, this);
        dispatcher.off(eventDispatchers.REMOVE_WILD_FROM_REEL, this.removeWildAfterCompletion, this);
        dispatcher.off(eventDispatchers.RESET_GLOW_EFFECT_ANIMATION, this.view.resetGlowAnimations, this.view);
        dispatcher.off(eventDispatchers.RESET_WILD_ON_REEL, this.resetWildPanel, this);
        dispatcher.off(eventDispatchers.COLLECTED_WILD_ON_BET_CHANGE, this.showCollectedWildOnNewBet, this);
        dispatcher.off(eventDispatchers.COLLECTED_WILD_ON_BROKEN, this.showCollectedWildOnBroken, this);
        dispatcher.off(eventDispatchers.HANDLE_TINT_WILD_SYMBOL, this.handleWildOnAnticipation, this);
        dispatcher.off(eventDispatchers.HANDLE_WILD_REEL_DURING_TOGGLE, this.handleWildReelTogglePresentation, this);
    }
    /**
     * function will show currently collected flowers in panel on broken and bet change
     */
    private showCollectedWildOnNewBet(): void {
        (ingenuity.parserModel as GameParserModel).getWildOnReel().forEach((reelId: number, index: number) => {
            const container: Container = this.view.getContainerByID("Reel_" + reelId + "_Container");
            dispatcher.fireEvent(eventDispatchers.HIDE_REEL_BEHIND_WILD_BG, reelId);
            if (!container.children[0]) {
                ingenuity.configData.checkForActualWild[reelId] = true
                let wildAnimation = this.view.cloneSpine();
                container.y = this.view.json.tween_ToY;
                container.addChild(wildAnimation);
                wildAnimation.playAnim("static", true);
            }
        })
        this.showLastSpinWild();
    }
    /**
     * function will show currently collected flowers in panel on broken and bet change
     */
    private showCollectedWildOnBroken(): void {
        (ingenuity.parserModel as GameParserModel).getPreWildOnReel().forEach((reelId: number, index: number) => {
            const container: Container = this.view.getContainerByID("Reel_" + reelId + "_Container");
            dispatcher.fireEvent(eventDispatchers.HIDE_REEL_BEHIND_WILD_BG, reelId);
            if (!container.children[0]) {
                ingenuity.configData.checkForActualWild[reelId] = true
                let wildAnimation = this.view.cloneSpine();
                container.y = this.view.json.tween_ToY;
                container.addChild(wildAnimation);
                wildAnimation.playAnim("static", true);
            }
        })
    }
    /**
     * function will show last wild (golden stack wild) on reel
     */
    private showLastSpinWild(): void {
        ingenuity.configData.checkForLastFlower.forEach((reelID: number) => {
            const container: Container = this.view.getContainerByID("Reel_" + reelID + "_Container");
            container.y = this.view.json.tween_ToY;
            let wildAnimation:SpineBase
            if (!container.children[0]) {
                wildAnimation = this.view.cloneSpine();
                container.addChild(wildAnimation);
                wildAnimation.playAnim("static", true);
            }else{
                wildAnimation = container.children[0]
                wildAnimation.playAnim("static", true);
            }
        })
    }
    /**
     * to check and show wild dragons on reel
     */
    private startWildDragonFeature(): void {
        const wildPosOnReel = (ingenuity.parserModel as GameParserModel).getWildOnReel();
        wildPosOnReel.forEach((reelId: number, index: number) => {
            const container: Container = this.view.getContainerByID("Reel_" + reelId + "_Container");
            if (!container.children[0]) {
                ingenuity.configData.checkForActualWild[reelId] = true
                this.currentLandedWilds.push(reelId);
                let wildAnimation = this.view.cloneSpine();
                container.addChild(wildAnimation);
                wildAnimation.playAnim("static", true);
                dispatcher.fireEvent(eventDispatchers.CREATE_ONION_MASK, reelId);
                this.tweenDownContainer(container, reelId, index);
            } else {
                if (!this.currentLandedWilds.length && index === (wildPosOnReel.length - 1)) {
                    dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
                }
            }
        });
    }
    /**
     * to twween down wild containers
     */
    private tweenDownContainer(container: Container, reelId: number, index: number): void {
        // container.y = this.view.json.tween_From_Y;
        // const wildReelContainerTween: ITween = ingenuity.currentGame.add.tween(container);
        // wildReelContainerTween.to({ y: this.view.json.tween_ToY }, 300, Linear.None, true, 0, 0, false);
        // (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_1X4_APPEAR, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
        // wildReelContainerTween.onComplete.addOnce(() => {
        //     ingenuity.currentGame.tweens.remove(wildReelContainerTween)
            // container.y = this.view.json.tween_ToY;
            this.playWildLandingEffectAnim(reelId);
            this.playWildLanding(container, reelId);
            dispatcher.fireEvent(eventDispatchers.WILD_LANDED_ON_REEL, reelId);
            dispatcher.fireEvent(eventDispatchers.REMOVE_ONION_MASK, reelId);
        // })
    }
    /**
     * to show landing glow effect
     */
    private playWildLandingEffectAnim(reelId: number): void {
        // let wildAnimation: SpineBase;
        // const effectContainer: Container = this.view.getContainerByID("Reel_effect_" + reelId + "_Container");
        // if (!effectContainer.children[0]) {
        //     wildAnimation = this.view.cloneSpine();
        //     effectContainer.addChild(wildAnimation);
        //     wildAnimation.playAnim("landing", false);
        // }
        // else {
        //     wildAnimation = effectContainer.children[0].playAnim("landing", false);
        // }
    }
    /**
     * to show wild landing
     */
    private playWildLanding(container: Container, reelId: number): void {
        container.children[0].playAnim("landing", false);
        (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_1X4_LOCK, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
        container.children[0].onComplete.addOnce(() => {
            container.children[0].playAnim("static", true);
            if (reelId === this.currentLandedWilds[this.currentLandedWilds.length - 1]) {
                dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
                this.currentLandedWilds = [];
            }
        })
    }
    /**play wild reel win animation during first toggle */
    private handleWildReelTogglePresentation(evt: IEvent): void {
        this.suspendWildDragonWin();
        const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
        this.view.json.getWildAnimCont.forEach((name: string, reelId: number) => {
            const winOffset: number[][] = evt.data
            for (let index = 0; index < winOffset.length; index++) {
                let container = this.view.getContainerByID(name)
                if (container.children.length) {
                    if ((reelId) == winOffset[index][0]) {
                        const WildReelContainer: Container = this.view.getContainerByID("Reel_" + (reelId) + "_Container");
                        WildReelContainer.children[0].onComplete.dispose();
                        WildReelContainer.children[0].state.timeScale = 1;
                        if (purpleWild.includes(reelId)) {
                            WildReelContainer.children[0].playAnim("win", true);
                        } else {
                            WildReelContainer.children[0].playAnim("win", true);
                        }
                        break;
                    }
                }
            }
        })
    }

    /**
    * to check and show wild dragons win anim
    */
    protected playWildWinAnim(): void {
        const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
        this.view.json.getWildAnimCont.forEach((name: string, reelId: number) => {
            const winOffset: number[][] = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions()
            for (let index = 0; index < winOffset.length; index++) {
                let container = this.view.getContainerByID(name)
                if (container.children.length) {
                    if ((reelId) == winOffset[index][0]) {
                        const WildReelContainer: Container = this.view.getContainerByID("Reel_" + (reelId) + "_Container");
                        WildReelContainer.children[0].onComplete.dispose();
                        WildReelContainer.children[0].state.timeScale = 1;
                        if (purpleWild.includes(reelId)) {
                            WildReelContainer.children[0].playAnim("win", true);
                        } else {
                            WildReelContainer.children[0].playAnim("win", true);
                        }
                        (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_1X4_WIN, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
                        break;
                    }
                }
            }
        })
    }
    /**
    * to check and play flower eating anim
    */
    private eatFlowerAnim(): void {
        const collectedFlowers: number[] = (ingenuity.parserModel as GameParserModel).getCollectedFlowers();
        let currReel: number = 0;
        collectedFlowers.forEach((currentFlower: number, index: number) => {
            const reelContainer: Container = this.wildDragonOnReelMainContainer.children[index];
            if (reelContainer && reelContainer.children.length && collectedFlowers[index] !== 0) {
                currReel = index;
                let actionAnim: string = "";
                // if (currentFlower >= 4) {
                //     actionAnim = "wild_1x4_action_3";
                // } else if ((currentFlower <= 3) && (index === 1 || index === 2 || index === 3)) {
                //     if (currentFlower === 3) {
                //         actionAnim = "wild_1x4_action_2";
                //     } else {
                //         actionAnim = "wild_1x4_action_1";
                //     }
                // } else if ((index === 0 || index === 4)) {
                //     actionAnim = "wild_1x4_action_" + currentFlower;
                // } 
                if (actionAnim == "") {
                    reelContainer.children[0].playAnim("static", false);
                    (ingenuity.soundManager as any).playSound(SoundConstantGame.WILD_1X4_FEED, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
                    reelContainer.children[0].onComplete.addOnce(() => {
                        reelContainer.children[0].playAnim("static", true);
                    });
                    dispatcher.fireEvent(eventDispatchers.EAT_FLOWER_BY_DRAGON, [currReel, currentFlower]);
                }
            }
        });
    }



    /**
    * to check and suspend wild dragon win 
    */
    private suspendWildDragonWin(): void {
        const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
        this.view.json.getWildAnimCont.forEach((name: string, index: number) => {
            let container = this.view.getContainerByID(name)
            if (container.children.length) {
                if (purpleWild.includes(index)) {
                    const WildReelContainer: Container = this.view.getContainerByID("Reel_" + (index) + "_Container");
                    WildReelContainer.children[0].playAnim("static", true);
                }
                else {
                    container.children[0].playAnim("static", true);
                }
            }
        })
    }
    /**
    * to check and show purple wild to golden wild 
    */
    private purpleWildToGoldAnim(): void {
        // const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
        // purpleWild.forEach((element: number, index: number) => {
        //     const WildReelContainer: Container = this.view.getContainerByID("Reel_" + (element) + "_Container");
        //     const wildSpine: SpineBase = WildReelContainer.children[0];
        //     wildSpine.state.timeScale = 1.5;// to increase time for this particular animation
        //     wildSpine.playAnim("landing2", false);
        //     wildSpine.onComplete.addOnce(() => {
        //         // if((ingenuity.parserModel as GameParserModel).getWildOnReel().length === 0){
        //         //     dispatcher.fireEvent(eventDispatchers.RESET_MINI_SKULL_ANIMATIONS);
        //         // }
        //         if (index === purpleWild.length - 1) {
        //             dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
        //         }
        //     })
        // });
        // if (purpleWild.length === 0) {
        dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
        // }
    }
    private removeWildAfterCompletion(evt: IEvent): void {
        const WildReelContainer: Container = this.view.getContainerByID("Reel_" + (evt.data) + "_Container");
        // const wildSpine: SpineBase = WildReelContainer?.children[0];
        
        // if(wildSpine){
        //     // wildSpine.state.timeScale = 2;// to increase time for this particular animation
        //     wildSpine.onComplete.dispose();
        //     wildSpine.playAnim("landing2", false);
        //     wildSpine.onComplete.addOnce(() => {
        //         WildReelContainer.children = [];
        //         ingenuity.configData.checkForActualWild[evt.data] = false;

        //     })
        // }else{
            WildReelContainer.children = [];
            ingenuity.configData.checkForActualWild[evt.data] = false;
        // }
    };
    /**
     * to show tint on wild
     */
    private handleWildOnAnticipation(evt: IEvent): void {
        ingenuity.configData.checkForActualWild.forEach((isWild: boolean, index: number) => {
            if (isWild) {
                const WildReelContainer: Container = this.view.getContainerByID("Reel_" + (index) + "_Container");
                if (WildReelContainer && WildReelContainer.children.length) {
                    WildReelContainer.children[0].tint = evt.data.tint
                }
            }
        })
    }

    /**
     * to reset wild dragon feature 
    */
    private resetWildPanel(): void {
        ingenuity.configData.checkForActualWild = [false, false, false, false, false]
        this.view.resetWildDragon();
        this.view.resetGlowAnimations();
    }

}